import React from 'react'
import { Layout } from './Layout'
import { useProps } from './useProps'

export const ArticlesTable = (params: { category: App.Article['category'] }) => {
  return <Layout {...useProps(params)} />
}
